export default __webpack_public_path__ + "static/media/Add.611c2576.svg";